// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuotedText__miniature-e74cfb {
  min-width: var(--message-bubble-min-width);
  max-width: var(--max-width-input-top-panel);
  width: 100%;
}

.QuotedText__icon-afd36c {
  fill: var(--base-60);
  flex-shrink: 0;
  margin-inline-end: 20px;
}

.QuotedText__title-bd1123 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--brand-primary-40);
}

.QuotedText__remove-fe9234 {
  color: var(--base-60);
  margin-inline-start: 12px;
}

.QuotedText__content-a6a288 {
  display: flex;
  gap: 6px;
}

.QuotedText__text-e2b811 {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-grow: 1;
}

.QuotedText__miniature-title-c5d7d3 {
  color: var(--brand-primary-40);
}

.QuotedText__miniature-text-c9d11c {
  color: var(--base-80);
}

.QuotedText__miniature-icon-fbe26c {
  fill: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/QuotedText/QuotedText.styles.m.css"],"names":[],"mappings":"AAAA;EACE,0CAAA;EACA,2CAAA;EACA,WAAA;AACF;;AAEA;EACE,oBAAA;EACA,cAAA;EACA,uBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,8BAAA;AACF;;AAEA;EACE,qBAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".miniature {\n  min-width: var(--message-bubble-min-width);\n  max-width: var(--max-width-input-top-panel);\n  width: 100%;\n}\n\n.icon {\n  fill: var(--base-60);\n  flex-shrink: 0;\n  margin-inline-end: 20px;\n}\n\n.title {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--brand-primary-40);\n}\n\n.remove {\n  color: var(--base-60);\n  margin-inline-start: 12px;\n}\n\n.content {\n  display: flex;\n  gap: 6px;\n}\n\n.text {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex-grow: 1;\n}\n\n.miniature-title {\n  color: var(--brand-primary-40);\n}\n\n.miniature-text {\n  color: var(--base-80);\n}\n\n.miniature-icon {\n  fill: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"miniature": `QuotedText__miniature-e74cfb`,
	"icon": `QuotedText__icon-afd36c`,
	"title": `QuotedText__title-bd1123`,
	"remove": `QuotedText__remove-fe9234`,
	"content": `QuotedText__content-a6a288`,
	"text": `QuotedText__text-e2b811`,
	"miniature-title": `QuotedText__miniature-title-c5d7d3`,
	"miniatureTitle": `QuotedText__miniature-title-c5d7d3`,
	"miniature-text": `QuotedText__miniature-text-c9d11c`,
	"miniatureText": `QuotedText__miniature-text-c9d11c`,
	"miniature-icon": `QuotedText__miniature-icon-fbe26c`,
	"miniatureIcon": `QuotedText__miniature-icon-fbe26c`
};
module.exports = ___CSS_LOADER_EXPORT___;
